<template>
  <div class="index">
    <div class="frontPage-head">
      <div class="frontPage-head-l">
        <div>
          <p>
            <img src="../assets/company.png" />
          </p>
        </div>
        <div>
          <p>上海齐獭信息科技有限公司</p>
          <p>Shanghai Qita information Co.,Ltd.</p>
        </div>
      </div>
      <div class="frontPage-head-r">
        <ul>
          <!-- <li v-for="(item, index) in nav" :key="index" @click="addClass(index)">
            <router-link :to="item.route" :class="{ bgColors:index==current}">
              <img :src="item.src" />
              {{item.text}}
            </router-link>
          </li>-->
          <li
            v-for="(item, index) in nav"
            :key="index"
            @click="addClass(index)"
            :class="{'bgColors':index==current}"
          >
            <img :src="item.src" />
            {{item.text}}
          </li>
        </ul>
      </div>
    </div>
    <div class="frontPage-content">
      <!-- <router-view /> -->
      <Company />
      <Product />
      <!-- <Client /> -->
    </div>
    <el-backtop :bottom="100">
      <div
        style="{
        height: 100%;
        width: 100%;;
        text-align: center;
        color: #fff;
      }"
      >
        <span class="back-icon"></span>回到顶部
      </div>
    </el-backtop>
    <div class="frontPage-bottom">
      <!-- <div class="frontPage-bottom-t">
        <div class="frontPage-t-m">
          <div>
            <p>关于齐獭</p>
            <p v-for="(item,index) in nav" :key="index">
              {{item.text}}
            </p>
          </div>
          <div>
            <p>关注我们：</p>
            <p>
              <img :src="hideIcon?src1:src2" @mouseover="iconHide" @mouseout="iconShow" />
            </p>
          </div>
          <div>
            <p>客服热线</p>
            <p>0755-23895073</p>
            <p style="font-size: 18px;">咨询时间</p>
            <p>9:00 - 19:00</p>
          </div>
          <div>
            <p>联系邮箱</p>
            <p>674995845@qq.com</p>
            <p style="font-size: 18px;">公司地址</p>
            <p>上海市闵行区吴中路1799号D座801室</p>
          </div>
        </div>
      </div>-->
      <div class="frontPage-bottom-b">
        <div>
          ©Copyright @ 2018-2024 上海齐獭信息科技有限公司版权所有
          <a
            target="_blank"
            href="https://beian.miit.gov.cn/"
          >沪ICP备19019259号-1</a>
          <a href="https://beian.mps.gov.cn/#/query/webSearch?code=31011202020750" rel="noreferrer" target="_blank"><img class="gong-an-img-cla" style="vertical-align:middle; margin: 0 5px;" src="../assets/gongan.png" />沪公网安备31011202020750</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Company from "./company-introduction";
import Product from "./product-capacity";
// import Client from "./client-case";
import "../style/mobile-phone.less";

export default {
  name: "index",
  components: {
    Company,
    Product
    // Client
  },
  data() {
    return {
      current: 0,
      hideIcon: true,
      src1: require("../assets/wx.png"),
      src2: require("../assets/wx2.png"),
      nav: [
        {
          src: require("../assets/company.png"),
          route: "company",
          text: "公司介绍"
        },
        {
          src: require("../assets/product.png"),
          route: "product",
          text: "产品及能力"
        }
        // {
        //   src: require("../assets/client.png"),
        //   route: "client",
        //   text: "客户案例"
        // }
      ]
    };
  },
  mounted: function() { 
    //滚动监听
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    /**
     * 点击导航栏变颜色+滚动监听
     * index为点击的下标
     */
    addClass(index) {
      this.current = index;
      // 获取点击的按钮对应页面的id
      let PageId = document.querySelector("#page" + index);
      // 打印出对应页面与窗口的距离
      //console.log(PageId.offsetTop);
      window.scrollTo(0, PageId.offsetTop - 76);
      //console.log(this.current)
    },
    iconHide() {
      this.hideIcon = false;
    },
    iconShow() {
      this.hideIcon = true;
    },
    handleScroll: function() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      //console.log("scrollTop",scrollTop)
      //获取第一个标签top
      var offsetTop = document.querySelector("#page1").offsetTop;
      //console.log(offsetTop)

      if (scrollTop > offsetTop - 77) {
        this.current = 1;
      } else {
        this.current = 0;
      }
      //console.log(this.current)
    }
  }
};
</script>

<style scoped lang="less">
.index {
  //background-image: url(../assets/index-bg.jpg);
  background-color: #f4f4f4;
}

li {
  list-style-type: none;
}
/* 头部 */
.frontPage-head {
  border-top: 5px solid #c20009;
  width: 100%;
  display: flex;
  justify-content: space-between;
  background-color: #fff;
  //background-color: rgba(146, 6, 6, 0.2);
  border-bottom: 1px solid #c20009;
  box-shadow: 0px 4px 3px #c6c6c6;
  position: fixed;
  top: 0;
  left: 0;
}

.frontPage-head-l {
  display: flex;
  justify-content: flex-start;
}

.frontPage-head-r {
  display: flex;
}

.frontPage-head-r ul {
  margin: 0 auto;
  padding: 0;
}

.frontPage-head-r ul .bgColors {
  color: #c20009;
}

// .frontPage-head-r ul .bgColors-n {
//   color: #000;
// }

// .frontPage-head-r img {
//   width: 28px;
//   margin: 0 4px;
//   padding: 0;
//   vertical-align: middle;
// }

// .frontPage-head-r ul a {
//   color: black;
//   // color: #fff;
//   text-decoration: none;
// }

.frontPage-head-r ul li {
  cursor: pointer;
  float: left;
}

.frontPage-head-l img {
  vertical-align: middle;
}

.frontPage-head-r img {
  vertical-align: middle;
}

.frontPage-head-l p {
  color: #c20009;
  text-align: left;
  font-weight: bold;
}
/* 内容 */
.frontPage-content {
  width: 80%;
  margin-left: 10%;
}
/* 回到顶部 */
@media (min-width: 1024px) {
  .el-backtop {
    height: 80px;
    width: 80px;
  }
}

@media (min-width: 767px) and (max-width: 1024px) {
  .el-backtop {
    width: 70px;
    height: 70px;
  }
}

@media (min-width: 480px) and (max-width: 767px) {
  .el-backtop {
    width: 50px;
    height: 50px;
  }
}

@media (max-width: 480px) {
  .el-backtop {
    width: 50px;
    height: 50px;
  }
}

.el-backtop {
  background-color: rgba(0, 0, 0, 0.4);
}

.el-backtop:hover {
  background-color: rgba(189, 4, 4, 0.9);
}
/* 底部 */
// .frontPage-bottom-t {
//   height: 200px;
//   background-image: url(../assets/bg.png);
//   display: flex;
// }

.frontPage-bottom-b {
  background-color: #181818;
  display: flex;
}

.frontPage-bottom-b div {
  width: 100%;
  text-align: center;
  //margin: 0 auto;
  color: #cbcbcb;
}

// .frontPage-t-m {
//   margin: auto;
//   width: 50%;
//   display: flex;
//   justify-content: space-between;
//   font-size: 14px;
//   color: #fff;
// }

// .frontPage-t-m img {
//   width: 80px;
//   margin: 10px 0;
// }

// .frontPage-t-m p {
//   margin: 0;
//   height: 34px;
//   line-height: 34px;
//   text-align: left;
// }

// .frontPage-t-m div:first-child p {
//   text-align: right;
// }

// .frontPage-t-m p:first-child {
//   font-size: 18px;
// }

.frontPage-t-m a,
.frontPage-bottom-b a {
  text-decoration: none;
  color: #cbcbcb;
  margin-left: 10px;
}
</style>
